import { boot, Intercom, update, shutdown as _shutdown } from "@intercom/messenger-js-sdk";

let appId = null;
let isInitialized = false;

export const VueIntercom = {
  install(app, options) {
    appId = options.APP_ID;
    if (appId && !options.delayedBoot) {
      Intercom({
        api_base: "https://api-iam.intercom.io",
        app_id: appId,
      });
      boot({
        api_base: "https://api-iam.intercom.io",
        app_id: appId,
      });
      isInitialized = true;
    }
    const isVue2 = (app) => app.version.split('.')[0] == 2
    if (isVue2(app)) {
      app.prototype.$updateIntercomUser = update;
    } else {
      app.config.globalProperties.updateIntercomUser = update;
    }
  },
};

export const initializeIntercom = () => {
  if (!appId || isInitialized) {
    return;
  }
  Intercom({
    api_base: "https://api-iam.intercom.io",
    app_id: appId,
  });
  boot({
    api_base: "https://api-iam.intercom.io",
    app_id: appId,
  });
  isInitialized = true;
};

export const updateUser = update;
export const shutdown = () => {
  _shutdown();
  isInitialized = false;
};
